import { AppStatus } from '../../../types/entities'

export const projectStatusLabel = (status: AppStatus): string => {
  const labels: Record<AppStatus, string> = {
    active: 'Ativo',
    maintenance: 'Manutenção',
    deprecated: 'Descontinuado',
    development: 'Em Desenvolvimento',
  }
  return labels[status]
}

export const projectStatusSeverity = (status: AppStatus): 'success' | 'warning' | 'danger' | 'info' => {
  const map: Record<AppStatus, 'success' | 'warning' | 'danger' | 'info'> = {
    active: 'success',
    maintenance: 'warning',
    deprecated: 'danger',
    development: 'info',
  }
  return map[status]
}
